export default function () {
	return {
		country_areas: [],
		faq_categories: [],
		genders: [],
		group_users_labels: [],
		groups_user: [],
		library_file_categories: [],
		trail_complete_categories: [],
		has_trailcomplete_null_category: false,
		library_file_extensions: [],
		marital_status: [],
		reward_categories: [],
		reward_departments: [],
		reward_levels: [],
		tags: [],
		countries: [],
		wildcard_pages: []
	}
}
